module.exports = __webpack_public_path__ + "static/media/bg-login-page.6ba8c269.jpg";